export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.client) {
    const AOS = await import('aos')
    await import('aos/dist/aos.css')

    nuxtApp.AOS = AOS.init()
  }
})
